import { Box, Container, IconButton, Stack, Typography } from "@mui/material";
import { BlTooltip } from "Components/_Shared/BlTooltip";
import { ClientsSearch } from "Components/_Shared/Client/ClientsSearch";
import { HStack } from "Components/_Shared/Core/Stack";
import { ReactComponent as CloseIcon } from "Components/_Shared/Icons/Assets/close.svg";
import type { SearchedClient, SearchedLocalClient } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { useNavigate } from "react-router-dom";

interface NewAnalysisHeaderProps {
  onClientSelect: (client: SearchedClient | SearchedLocalClient) => void;
}

export const NewAnalysisHeader = ({ onClientSelect }: NewAnalysisHeaderProps) => {
  const { t } = useResource();
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" disableGutters>
      <Stack spacing={Spacing.S} px={Spacing.L}>
        <HStack justifyContent="space-between" alignItems="center">
          <Typography variant="h2">{t(Resources.NewAnalysis.Title)}</Typography>
          <BlTooltip title={t(Resources.Common.Close)}>
            <IconButton onClick={() => navigate(AppRouting.Analyses.path())} aria-label={t(Resources.Common.Close)}>
              <CloseIcon />
            </IconButton>
          </BlTooltip>
        </HStack>
      </Stack>
      <Box pt={Spacing.XXL} px={Spacing.L}>
        <ClientsSearch includeLocalClients showAnalysisStatus onSelect={onClientSelect} onSelectLocal={onClientSelect} />
      </Box>
    </Container>
  );
};
